//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhotoSwipe from "photoswipe/dist/photoswipe";
import UI from "photoswipe/dist/photoswipe-ui-default";
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const targetElement = document.querySelector("#pswp");
export default {
  methods: {
    open(
      index,
      list,
      params = { }
    ) {
      let options = Object.assign(
        {
          index: index,
          bgOpacity:.4,
          getThumbBoundsFn(index) {
            let thumbnail = document.querySelectorAll(".preview-img")[index];
            let pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            let rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        },
        params
      );
      this.photoswipe = new PhotoSwipe(this.$el, UI, list, options);
      //console.log('this.photoswipe',this.photoswipe)
      this.photoswipe.init();
      this.photoswipe.listen('close', function() { 
        //console.log('close')
        enableBodyScroll(targetElement);
      });
      //console.log('init')
      disableBodyScroll(targetElement);
    },
    close() {
      enableBodyScroll(targetElement);
      this.photoswipe.close();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/preview/preview.vue